/*------------------------------------*\
    input
\*------------------------------------*/

module.exports = function(){

    // Replace input placeholder content on focus

    var $input = $('.js-input-placeholder');

    $input.focus(function() {

        var $inputPlaceholderText = $(this).attr('placeholder');
        var $inputFocusText = $(this).data('focus-placeholder');

        $(this).attr('placeholder', $inputFocusText).fadeIn(500);

        // Put the original placeholder back on blur

        $(this).blur(function() {

            $(this).attr('placeholder', $inputPlaceholderText);

        });

    });


}; // end of module.exports





// WEBPACK FOOTER //
// ./js-source/blocks/input.js